import { useQuery } from '@tanstack/react-query';
import { api, queryKeys } from '../lib/api';

function Dot({ state }: { state: 'ok' | 'fail' | 'pending' }) {
  const color = state === 'ok' ? 'bg-ok' : state === 'fail' ? 'bg-fail' : 'bg-warn';
  return <span aria-hidden className={`inline-block size-2.5 rounded-full ${color}`} />;
}

/** Phase 0 smoke test: shows GET /readyz from the API through the dev proxy / nginx. */
export function ServerStatus() {
  const q = useQuery({
    queryKey: queryKeys.readyz,
    queryFn: () => api.readyz(),
    refetchInterval: 30_000,
  });

  const overall: 'ok' | 'fail' | 'pending' = q.isPending
    ? 'pending'
    : q.isError || q.data?.status !== 'ok'
      ? 'fail'
      : 'ok';

  return (
    <section aria-labelledby="server-status" className="card p-4">
      <h2
        id="server-status"
        className="mb-2 flex items-center gap-2 text-sm font-semibold text-muted"
      >
        <Dot state={overall} /> Server
      </h2>
      {q.isPending ? (
        <p className="text-sm text-muted">Checking…</p>
      ) : q.isError ? (
        <p className="text-sm text-fail">Unreachable: {q.error.message}</p>
      ) : (
        <dl className="grid grid-cols-2 gap-x-4 gap-y-1 text-sm">
          <dt className="text-muted">Database</dt>
          <dd className="flex items-center gap-2">
            <Dot state={q.data.checks.database} /> {q.data.checks.database}
          </dd>
          <dt className="text-muted">Media</dt>
          <dd className="flex items-center gap-2">
            <Dot state={q.data.checks.media} /> {q.data.checks.media}
          </dd>
        </dl>
      )}
    </section>
  );
}
